export default __webpack_public_path__ + "static/media/better-payment.9d713cb1.jpg";